module.exports = __webpack_public_path__ + "img/invite_earnings.08a8c13b.png";